"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "veroli": {
    "118d27ab": [{
      "hkey": "9409720d",
      "slug": "san-giuseppe-le-prata-cotropagno",
      "name": "San Giuseppe le Prata-Cotropagno",
      "primary": true,
      "skipSearch": false
    }],
    "catropagno": [{
      "hkey": "9409720d",
      "slug": "san-giuseppe-le-prata-cotropagno",
      "name": "San Giuseppe le Prata-Cotropagno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "veroli"
    }],
    "f4d79988": [{
      "hkey": "255f4511",
      "slug": "sant-angelo-in-villa-giglio",
      "name": "Sant'Angelo in Villa-Giglio",
      "primary": true,
      "skipSearch": false
    }],
    "giglio": [{
      "hkey": "255f4511",
      "slug": "sant-angelo-in-villa-giglio",
      "name": "Sant'Angelo in Villa-Giglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "veroli"
    }],
    "272cb0dd": [{
      "hkey": "9409720d",
      "slug": "san-giuseppe-le-prata-cotropagno",
      "name": "San Giuseppe le Prata-Cotropagno",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuseppe-le-prata": [{
      "hkey": "9409720d",
      "slug": "san-giuseppe-le-prata-cotropagno",
      "name": "San Giuseppe le Prata-Cotropagno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ec67654c": [{
      "hkey": "255f4511",
      "slug": "sant-angelo-in-villa-giglio",
      "name": "Sant'Angelo in Villa-Giglio",
      "primary": true,
      "skipSearch": false
    }],
    "sant-angelo-in-villa": [{
      "hkey": "255f4511",
      "slug": "sant-angelo-in-villa-giglio",
      "name": "Sant'Angelo in Villa-Giglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;